<div class="dispatch-container">
  <p role="note">
    O comunicado será enviado aos destinatários selecionados, inclusive endereços externos. Confira
    a seleção antes de confirmar. O histórico confirma aceitação pelo provedor, não entrega na caixa
    de entrada.
  </p>
  @if (loading) {
    <div class="page-loader">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <fieldset class="compose-fields" [disabled]="enviando" aria-label="Composição do comunicado">
      <!-- Etapa 1: destinatários -->
      <mat-card class="etapa-card">
        <mat-card-title class="etapa-header">
          <mat-icon class="etapa-icon">group</mat-icon>
          <span>1. Destinatários</span>
        </mat-card-title>

        <!-- Adicionar box de busca de médico específico -->

        <mat-card-content class="etapa-content">
          <!-- A caixa toda é a área de importar: ela tem cara de dropzone, então
             clicar em qualquer ponto dela abre o seletor, e não só no botão.
             Também aceita arrastar o arquivo para dentro. -->
          <div
            class="import-box"
            [class.arrastando]="arrastandoCsv"
            (click)="csvInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onCsvDrop($event)"
          >
            <div class="import-texto">
              <mat-icon>upload_file</mat-icon>
              <div>
                <strong>Importe a lista por CSV</strong>
                <p>
                  Clique aqui ou arraste o arquivo. Ele precisa da coluna
                  <code>e-mail</code>; a coluna <code>nome</code> é opcional e usada na saudação.
                </p>
              </div>
            </div>

            <input
              #csvInput
              type="file"
              accept=".csv,text/csv"
              class="input-arquivo"
              tabindex="-1"
              aria-hidden="true"
              (change)="onCsvSelected(csvInput.files); csvInput.value = ''"
            />

            <button mat-stroked-button class="import-btn" type="button">
              <mat-icon>attach_file</mat-icon>
              Escolher arquivo CSV
            </button>
          </div>

          @if (nomeArquivoCsv) {
            <div class="import-resultado">
              <span class="chip ok">{{ destinatarios.length }} válidos</span>
              @if (invalidos.length) {
                <span class="chip erro">{{ invalidos.length }} inválidos</span>
                <button mat-button (click)="baixarInvalidos()">
                  <mat-icon>file_download</mat-icon>
                  Baixar inválidos
                </button>
              }
              <span class="arquivo-nome">{{ nomeArquivoCsv }}</span>
            </div>
          }

          @if (destinatarios.length) {
            <table
              mat-table
              [dataSource]="destinatarios"
              class="mat-elevation-z8 tabela-destinatarios"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    aria-label="Selecionar todos os destinatários"
                    [disabled]="enviando"
                    [checked]="todosSelecionados()"
                    (change)="alternarTodos()"
                  ></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox
                    [aria-label]="'Selecionar destinatário ' + row.nome + ' (' + row.email + ')'"
                    [disabled]="enviando"
                    [checked]="selecionados.has(row)"
                    (change)="toggleSelecao(row)"
                  ></mat-checkbox>
                </td>
              </ng-container>

              <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>E-mail</th>
                <td mat-cell *matCellDef="let row">{{ row.email }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          }
        </mat-card-content>
      </mat-card>

      <!-- Etapa 2: conteúdo -->
      <mat-card class="etapa-card">
        <mat-card-title class="etapa-header">
          <mat-icon class="etapa-icon">mail</mat-icon>
          <span>2. Conteúdo do e-mail</span>
        </mat-card-title>

        <mat-card-content class="etapa-content">
          <mat-form-field appearance="outline" class="campo-assunto">
            <mat-label>Assunto</mat-label>
            <input matInput [formControl]="assuntoControl" placeholder="Assunto do comunicado" />
          </mat-form-field>

          <div class="conteudo-grid">
            <div class="template-escolha">
              <button
                mat-stroked-button
                class="import-btn"
                (click)="abrirGaleria()"
                [disabled]="!templates.length"
              >
                <mat-icon>dashboard_customize</mat-icon>
                Escolher template
              </button>

              @if (templateEscolhido) {
                <div class="template-info">
                  <span class="arquivo-nome">{{ templateEscolhido.nome }}</span>
                  <button mat-button (click)="togglePreview()">
                    <mat-icon>{{ mostrarPreview ? 'visibility_off' : 'visibility' }}</mat-icon>
                    {{ mostrarPreview ? 'Ocultar' : 'Pré-visualizar' }}
                  </button>
                  <button
                    mat-icon-button
                    matTooltip="Remover template"
                    aria-label="Remover template selecionado"
                    (click)="removerTemplate()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>

            <div class="html-upload">
              <input
                #htmlInput
                type="file"
                accept=".html,text/html"
                class="input-arquivo"
                tabindex="-1"
                aria-hidden="true"
                (change)="onHtmlSelected(htmlInput.files); htmlInput.value = ''"
              />

              <button mat-stroked-button class="import-btn" (click)="htmlInput.click()">
                <mat-icon>code</mat-icon>
                Importar HTML
              </button>

              @if (nomeArquivoHtml) {
                <div class="html-info">
                  <span class="arquivo-nome">{{ nomeArquivoHtml }}</span>
                  <button mat-button (click)="togglePreview()">
                    <mat-icon>{{ mostrarPreview ? 'visibility_off' : 'visibility' }}</mat-icon>
                    {{ mostrarPreview ? 'Ocultar' : 'Pré-visualizar' }}
                  </button>
                  <button
                    mat-icon-button
                    matTooltip="Remover HTML"
                    aria-label="Remover HTML importado"
                    (click)="removerHtml()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>

          @if (mostrarPreview && corpoAtual) {
            <div class="preview-box">
              <div class="preview-titulo">
                <mat-icon>{{ modoEdicao ? 'edit_note' : 'desktop_windows' }}</mat-icon>
                <span>{{ modoEdicao ? 'Editando o conteúdo' : 'Pré-visualização' }}</span>

                @if (conteudoAlterado) {
                  <span class="chip-editado">conteúdo ajustado</span>
                }

                <span class="preview-acoes">
                  @if (modoEdicao) {
                    <button mat-button (click)="restaurarOriginal()" [disabled]="!conteudoAlterado">
                      <mat-icon>undo</mat-icon>
                      Restaurar original
                    </button>
                    <button mat-button (click)="abrirSalvarTemplate()">
                      <mat-icon>bookmark_add</mat-icon>
                      Salvar como novo template
                    </button>
                    <button mat-flat-button color="primary" (click)="concluirEdicao()">
                      <mat-icon>check</mat-icon>
                      Concluir
                    </button>
                  } @else {
                    <button mat-button (click)="editarConteudo()">
                      <mat-icon>edit</mat-icon>
                      Editar conteúdo
                    </button>
                  }
                </span>
              </div>

              @if (salvandoTemplate) {
                <div class="salvar-template">
                  <mat-form-field appearance="outline" class="campo-nome-template">
                    <mat-label>Nome do novo template</mat-label>
                    <input matInput [formControl]="nomeNovoTemplateControl" />
                    <mat-hint>O template de origem não é alterado.</mat-hint>
                  </mat-form-field>
                  <button mat-stroked-button (click)="cancelarSalvarTemplate()">Cancelar</button>
                  <button
                    mat-flat-button
                    color="primary"
                    [disabled]="!nomeNovoTemplateControl.value"
                    (click)="salvarComoNovoTemplate()"
                  >
                    Salvar
                  </button>
                </div>
              }

              @if (modoEdicao) {
                <div class="editor-box">
                  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                  <ngx-editor [editor]="editor" [formControl]="conteudoControl"></ngx-editor>
                </div>
              } @else if (htmlSeguro) {
                <iframe
                  class="preview-frame"
                  sandbox
                  title="Pré-visualização do e-mail"
                  [srcdoc]="htmlSeguro"
                ></iframe>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>

      <!-- Etapa 3: envio -->
      <mat-card class="etapa-card">
        <mat-card-title class="etapa-header">
          <mat-icon class="etapa-icon">send</mat-icon>
          <span>3. Enviar</span>
        </mat-card-title>

        <mat-card-content class="etapa-content">
          <mat-form-field appearance="outline" class="campo-nome-disparo">
            <mat-label>Nome do disparo</mat-label>
            <input
              matInput
              [formControl]="nomeDisparoControl"
              placeholder="Ex.: Convite evento setembro"
            />
            <mat-icon matSuffix>label</mat-icon>
            <mat-hint>
              Identifica este envio no Histórico. Não aparece para o destinatário.
            </mat-hint>
          </mat-form-field>

          @if (modoEdicao) {
            <p role="note">Conclua a edição do conteúdo antes de enviar o comunicado.</p>
          }
          <div class="envio-resumo">
            <div class="contador">
              <span class="numero">{{ selecionados.size }}</span>
              <span class="rotulo">destinatário(s) selecionado(s)</span>
            </div>

            <div class="envio-acoes">
              <button mat-stroked-button (click)="limpar()">
                <mat-icon>refresh</mat-icon>
                Limpar
              </button>
              <button
                mat-raised-button
                color="primary"
                class="enviar-btn"
                [disabled]="!podeEnviar()"
                (click)="confirmar()"
              >
                <mat-icon>send</mat-icon>
                {{ enviando ? 'Enviando...' : 'Enviar comunicado' }}
              </button>
            </div>
          </div>

          <p class="nota">
            <mat-icon>info</mat-icon>
            Disparos pontuais não alteram o status de nenhum pedido. A ação fica registrada no
            histórico.
          </p>
        </mat-card-content>
      </mat-card>
    </fieldset>
  }
</div>
